import { FieldConfig, FilterValue } from '@ideapa/common-interfaces';
import { DeepPartial } from '@ideapa/common-utils';
import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';

import { SharedEntityActions } from './models';

export function createActionsFactory<Entity>(ENTITY: string) {
  function getActions(): SharedEntityActions<Entity> {
    const loadPaged = createAction(
      `[Shared/${ENTITY}] Load Paged ${ENTITY}`,
      props<{
        skip: number;
        take: number;
        orderBy?: { [field: string]: 'asc' | 'desc' };
        filters?: FilterValue[];
        join?: string[];
      }>()
    );

    const loadPagedSuccess = createAction(
      `[Shared/${ENTITY}] Load Paged ${ENTITY} Success`,
      props<{
        items: Entity[];
      }>()
    );

    const loadPagedFailure = createAction(
      `[Shared/${ENTITY}] Load Paged ${ENTITY} Failure`,
      props<{ error: string }>()
    );

    const loadSingle = createAction(
      `[Shared/${ENTITY}] Load Single ${ENTITY}`,
      props<{ id: number }>()
    );
    const loadSingleSuccess = createAction(
      `[Shared/${ENTITY}] Load Single ${ENTITY} Success`,
      props<{ item: Entity }>()
    );
    const loadSingleFailure = createAction(
      `[Shared/${ENTITY}] Load Single ${ENTITY} Failure`,
      props<{ error: string }>()
    );

    const loadAll = createAction(`[Shared/${ENTITY}] Load All ${ENTITY}`);
    const loadAllSuccess = createAction(
      `[Shared/${ENTITY}] Load All ${ENTITY} Success`,
      props<{ items: Entity[] }>()
    );
    const loadAllFailure = createAction(
      `[Shared/${ENTITY}] Load All ${ENTITY} Failure`,
      props<{ error: string }>()
    );

    const update = createAction(
      `[Shared/${ENTITY}] Update ${ENTITY}`,
      props<{
        update: Update<Entity>;
        notify: boolean;
        goBack: boolean;
        callback?: (item: Entity) => void;
      }>()
    );
    const updateSuccess = createAction(
      `[Shared/${ENTITY}] Update ${ENTITY} Success`,
      props<{
        item: Entity;
        notify: boolean;
        goBack: boolean;
        callback?: (item: Entity) => void;
      }>()
    );

    const updateManySuccess = createAction(
      `[Shared/${ENTITY}] Update many ${ENTITY} Success`,
      props<{
        items: Entity[];
      }>()
    );

    const updateFailure = createAction(
      `[Shared/${ENTITY}] Update ${ENTITY} Failure`,
      props<{ error: string; notify: boolean }>()
    );

    const add = createAction(
      `[Shared/${ENTITY}] Add ${ENTITY}`,
      props<{ item: DeepPartial<Entity>; notify: boolean; goBack: boolean }>()
    );

    const addSuccess = createAction(
      `[Shared/${ENTITY}] Add ${ENTITY} Success`,
      props<{ item: Entity; notify: boolean; goBack: boolean }>()
    );

    const addFailure = createAction(
      `[Shared/${ENTITY}] Add ${ENTITY} Failure`,
      props<{ error: string; notify: boolean }>()
    );

    const deleteEntity = createAction(
      `[Shared/${ENTITY}] Delete ${ENTITY}`,
      props<{
        id: number;
        notify: boolean;
        goBack: boolean;
        callback?: () => void;
      }>()
    );

    const deleteEntitySuccess = createAction(
      `[Shared/${ENTITY}] Delete ${ENTITY} Success`,
      props<{
        id: number;
        notify: boolean;
        goBack: boolean;
        callback?: () => void;
      }>()
    );

    const deleteEntityFailure = createAction(
      `[Shared/${ENTITY}] Delete ${ENTITY} Failure`,
      props<{ error: string; notify: boolean }>()
    );

    const downloadExcel = createAction(
      `[Shared/${ENTITY}] Download downloadExcel`,
      props<{
        fileName?: string;
        columns?: FieldConfig[];
        filters?: FilterValue[];
        orderBy?: { [field: string]: 'asc' | 'desc' };
        join?: string[];
        notify: boolean;
      }>()
    );

    const downloadExcelSuccess = createAction(
      `[Shared/${ENTITY}] Download downloadExcel Success`,
      props<{
        responseFile: ArrayBuffer;
        notify: boolean;
      }>()
    );

    const downloadExcelFailure = createAction(
      `[Shared/${ENTITY}] Download downloadExcel Failure`,
      props<{
        error: string;
        notify: boolean;
      }>()
    );

    const clearCache = createAction(`[Shared/${ENTITY}] Clear Cache`);

    return {
      loadPaged,
      loadPagedSuccess,
      loadPagedFailure,
      loadAll,
      loadAllSuccess,
      loadAllFailure,
      loadSingle,
      loadSingleSuccess,
      loadSingleFailure,
      update,
      updateSuccess,
      updateManySuccess,
      updateFailure,
      add,
      addSuccess,
      addFailure,
      downloadExcel,
      downloadExcelSuccess,
      downloadExcelFailure,
      deleteEntity,
      deleteEntitySuccess,
      deleteEntityFailure,
      clearCache,
    };
  }

  return { getActions };
}
